module.exports = __webpack_public_path__ + "static/media/rubik-v14-latin-600.3a7877de.ttf";